import React, { useState, useEffect } from 'react';
import './ResponsiveTable.scss';

interface Column {
  key: string;
  header: string;
  render?: (value: any, row: any) => React.ReactNode;
}

interface ResponsiveTableProps {
  columns: Column[];
  data: any[];
}

const ResponsiveTable: React.FC<ResponsiveTableProps> = ({ columns, data }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (isMobile) {
    return (
      <div className="responsive-table__mobile">
        {data.map((row, index) => (
          <div key={index} className="responsive-table__mobile-row">
            {columns.map((column) => (
              <div key={column.key} className="responsive-table__mobile-field">
                <strong className="responsive-table__mobile-label">
                  {column.header}:
                </strong>
                <div className="responsive-table__mobile-value">
                  {column.render ? column.render(row[column.key], row) : row[column.key]}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="responsive-table__desktop">
      <div 
        className="responsive-table__desktop-grid"
        style={{ gridTemplateColumns: `repeat(${columns.length}, 1fr)` }}
      >
        {columns.map((column) => (
          <div key={column.key} className="responsive-table__desktop-header">
            {column.header}
          </div>
        ))}
        
        {data.map((row, rowIndex) => 
          columns.map((column) => (
            <div key={`${rowIndex}-${column.key}`} className="responsive-table__desktop-cell">
              {column.render ? column.render(row[column.key], row) : row[column.key]}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ResponsiveTable;